import React from 'react'
import FormSkuList from 'components/forms/FormSkuList'
import { updateObject } from 'helpers/objectHelpers'

const ProductSliderContent = ({
  value,
  value: {
    skuList = [],
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <FormSkuList
      value={skuList}
      onChange={(val) => handleChange(val, 'skuList')}
    />
  )
}

ProductSliderContent.propTypes = {}
ProductSliderContent.defaultProps = {}

export default ProductSliderContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/productSlider/ProductSliderContent.js